<template>
  <div class="wrap" id="AstroCalendarNoteList">
    <!---------------- To Edit Today-------------- -->
    <div class="toEditToday">
      <div class="toEditToday__main">
        <div class="toEditToday__main__line"></div>
        <div class="toEditToday__main__info">
          <div class="toEditToday__main__info__today">
            <img src="@/assets/共時曆/bigStart.svg" alt="" />
            <span> 每月笔记列表</span>
          </div>
        </div>
        <div class="toEditToday__main__line"></div>
      </div>
    </div>
    <div class="header">
      <div class="filterBar">
        <label>
          <img class="serachIcon" src="@/assets/占星小鋪/search.svg" alt="" />
          <input
            type="text"
            placeholder="搜尋筆記內容"
            v-model.trim="filterKey"
            @keyup.enter="searchHandler"
          />
        </label>
        <button class="filter_btn" @click="searchHandler">搜寻</button>
        <div class="moonlist__export" @click="openMoondayExport = true">
          <img src="../../assets/月亮日記/Download.svg" alt="" />
        </div>
        <div class="addMoonNote_btn" @click="addMoonNoteHandler()">
          <img src="@/assets/月亮日記/月亮日記加.svg" alt="" />
          <!-- <img
              class="hidden-pad-up"
              src="@/assets/月亮日記/月亮日記加加有顏色.svg"
              alt=""
            /> -->
        </div>
      </div>
    </div>
    <!---------------- Moon Statistics-------------- -->
    <AstroCalendarNoteStatistics
      v-show="List_filter.length"
      v-if="statisticsReady"
      :statistics="statistics"
    />
    <!---------------- Moon List Option-------------- -->
    <div class="moon_list_option" v-show="List_filter.length">
      <div class="moon_list_option_sort" @click="sortHandler()">
        <div class="moon_icon" :class="{ sorting: orderWay === 'ASC' }">
          <img src="../../assets/月亮日記/月亮日記排序.svg" alt="" />
        </div>
        {{ orderWay === "ASC" ? "遠到近" : "近到遠" }}
      </div>
    </div>
    <!-- 列表6/27改成沒有區分  寬度788-->
    <div class="moon_list_group" v-if="List_filter.length">
      <AstroCalendarNoteCard
        v-for="item in List_filter"
        :key="item.CalendarNoteId"
        :note="item"
        :nowloginPlatform="nowloginPlatform"
        @edit="editMoonNoteHandler"
        @delete="deleteMoonNoteHandler"
        @detail="toDetail"
      ></AstroCalendarNoteCard>
    </div>
    <div class="moon_list_empty" v-else>
      <div class="moon_list_empty_title">开始写你的第一篇笔记吧！</div>
      <div class="moon_list_empty_btn" @click="addMoonNoteHandler()">
        <img src="@/assets/icon-edit_white.svg" alt="" />
        开始撰写
      </div>
    </div>
    <!-- 分頁 -->
    <v-pagination
      v-if="List_filter.length > 0"
      v-model="pageIndex"
      class="my-4"
      :length="pageLength"
    ></v-pagination>

    <AstroCalendarExport
      v-show="openMoondayExport"
      @close="openMoondayExport = false"
    ></AstroCalendarExport>
  </div>
</template>
  
  <script>
import AstroCalendarExport from "@/components/共時曆/AstroCalendarExport.vue";
import AstroCalendarNoteStatistics from "@/components/共時曆/AstroCalendarNoteStatistics";
import AstroCalendarNoteCard from "@/components/共時曆/AstroCalendarNoteCard";
import moment from "moment";
import emotionList from "@/js/emotionList.js";

export default {
  components: {
    AstroCalendarExport,
    AstroCalendarNoteStatistics,
    AstroCalendarNoteCard,
  },
  props: ["selectedDate"],
  data() {
    return {
      emotionList,
      statistics: {
        Happy: 0,
        Calm: 0,
        Frightened: 0,
        Sad: 0,
        Angry: 0,
      },
      statisticsReady: false,
      List_filter: [],
      TotalCount: 0,
      filterKey: "",
      //分頁
      pageSize: 10,
      privitePageIndex: 1,
      orderWay: "DESC", //ASC
      openMoondayExport: false,
      fetchId: 0,
      //swiper
      swiperOption: {
        slidesPerView: "auto",
        spaceBetween: 12,
        freeMode: true,
      },
      Year: "",
      Month: "",
    };
  },
  async created() {
    this.$store.commit("setLoading_force", true);
    if (!this.hasEligibleProduct) {
      let productId = this.$store.getters.productListMap["Calendar2026"];
      this.$router.replace(`/store/detail/${productId}`);
      this.$store.commit("setLoading_force", false);
    } else {
      this.$store.commit("setLoading_force", false);
    }
  },
  computed: {
    hasEligibleProduct() {
      return this.$store.state?.userData?.CalendarInfo?.IsOwned2026;
    },
    nowloginPlatform() {
      return localStorage.loginMethods;
    },
    pageLength() {
      return Math.ceil(this.TotalCount / this.pageSize) || 1;
    },
    pageIndex: {
      set(value) {
        this.privitePageIndex = value;
        this.fetchData();
      },

      get() {
        return this.privitePageIndex || 1;
      },
    },
    nowUserData() {
      return this.$store.state.nowUserData;
    },
  },
  methods: {
    moment,
    async fetchData() {
      const currentFetchId = ++this.fetchId;
      try {
        let { data } = await this.$API.GET_CalendarNoteList({
          Year: this.Year * 1,
          Month: this.Month * 1,
          OrderWay: this.orderWay,
          PageSize: this.pageSize,
          PageIndex: this.pageIndex || 1,
          Content: this.filterKey,
        });
        if (currentFetchId !== this.fetchId) return;
        this.TotalCount = data.Data.TotalCount;
        this.List_filter = [...data.Data.Datas];
        this.fetchStatistics();
        window.scrollTo(0, 0);
      } catch (error) {
        if (currentFetchId !== this.fetchId) return;
        console.error(error);
      }
    },
    async fetchStatistics() {
      const currentFetchId = this.fetchId;
      this.statisticsReady = false;
      try {
        let { data } = await this.$API.GET_CalendarNoteMoodStatistics({
          Year: this.Year * 1,
          Month: this.Month * 1,
          Content: this.filterKey,
        });
        if (currentFetchId !== this.fetchId) return;
        this.statistics = data.Data;
        this.statisticsReady = true;
      } catch (error) {
        if (currentFetchId !== this.fetchId) return;
        console.error(error);
      }
    },
    searchHandler() {
      this.fetchData();
    },
    async addMoonNoteHandler() {
      this.$store.commit("setAstroCalendarNoteEdit", {
        CalendarNoteId: "",
        Content: "",
        MoodContent: "",
        Date: moment(new Date()).format("YYYY-MM-DD"),
      });
      this.$router.push("/astroCalendar/note/create");
    },
    toDetail(item) {
      this.$router.push(`/astroCalendar/note/${item.CalendarNoteId}`);
    },
    replaceBr(str) {
      return str.replace(/\n/g, "<br />");
    },
    splitMood(mood) {
      return mood.split("|");
    },
    editMoonNoteHandler(noteObj) {
      this.$router.push(`/astroCalendar/note/edit/${noteObj.CalendarNoteId}`);
    },
    deleteMoonNoteHandler(noteObj) {
      this.$messagePopup(
        "刪除筆記",
        "確定要刪除該筆記嗎？",
        "刪除",
        async () => {
          try {
            let { data } = await this.$API.DELETE_CalendarNote(
              noteObj.CalendarNoteId
            );
            if (data.Result) {
              this.$store.commit("update_toast", ["刪除成功"]);
              this.List_filter = this.List_filter.filter(
                (item) => item.CalendarNoteId !== noteObj.CalendarNoteId
              );
              if (this.List_filter.length === 0 && this.pageIndex > 1) {
                this.pageIndex--;
              } else {
                this.fetchData();
              }
            } else {
              this.$store.commit("update_toast", ["刪除失敗，請稍後再試"]);
            }
          } catch (error) {
            this.$store.commit("update_toast", ["刪除失敗，請稍後再試"]);
          }
        },
        true,
        true
      );
    },
    sortHandler() {
      this.orderWay = this.orderWay === "ASC" ? "DESC" : "ASC";
      this.fetchData();
    },
    highlightKeyword(Content) {
      let keyword = this.filterKey;
      let reg = new RegExp(keyword, "g");
      let match = Content.match(reg);
      let copyContent = Content;
      if (match) {
        let targetIndex = Content.indexOf(keyword);
        if (targetIndex > 60) {
          Content =
            copyContent.slice(0, 40) +
            "..." +
            copyContent.slice(targetIndex - 10);
        }
        return Content.replace(reg, `<span class="keyword">${keyword}</span>`);
      } else {
        return Content;
      }
    },
  },
  watch: {
    selectedDate: {
      handler(newDate, oldDate) {
        let oldYear = this.Year;
        let oldMonth = this.Month;
        this.Year = moment(newDate).format("YYYY");
        this.Month = moment(newDate).format("MM");
        if (oldYear !== this.Year || oldMonth !== this.Month) {
          this.fetchData();
        }
      },
      immediate: true,
    },
  },
};
</script>
  
  <style lang="scss">
@import "@/scss/_mixin.scss";
@import "@/scss/toast.scss";
@import "@/scss/dialog.scss";
.wrap#AstroCalendarNoteList {
  padding-top: 20px;
  width: 100%;
  max-width: 1094px;
  margin: 0 auto;
  min-height: 100vh;
  letter-spacing: 0.08em;
  @include pad {
    padding: 16px 23px 0;
  }
  .header {
    display: flex;
    @include pad {
      flex-direction: column;
      align-items: center;
    }
    h2.st_title {
      font-weight: 500;
      font-size: 40px;
      line-height: 58px;
      color: $theme-color-2;
      display: flex;
      align-items: center;
      margin-right: auto;
      @include mobile {
        margin: 0 auto;
        font-size: 18px;
        line-height: 26px;
        justify-content: center;
      }
      img {
        width: 54px;
        margin-right: 16px;
        @include mobile {
          width: 30px;
          margin-right: 5px;
        }
      }
    }

    .filterBar {
      margin: 42px 0;
      display: flex;
      justify-content: center;
      align-items: center;
      @include mobile {
        width: 100%;
        margin-top: 8px;
        margin-bottom: 24px;
        justify-content: flex-start;
      }
      label {
        width: 375px;
        height: 36px;
        position: relative;
        @include mobile {
          max-width: calc(100% - 172px);
          height: 36px;
        }
        .serachIcon {
          position: absolute;
          left: 20px;
          top: 50%;
          transform: translateY(-50%);
          @include mobile {
            left: 0;
          }
        }
        input,
        input:focus {
          width: 100%;
          height: 100%;
          background: #f0f2f4;
          box-shadow: 2px 2px 4px rgba(238, 109, 175, 0.22), inset 2px 2px 4px rgba(0, 0, 0, 0.15);
          border-radius: 25px;
          outline: none;
          padding: 8px 46px;
          @include mobile {
            box-shadow: none;
            padding: 8px 12px 8px 24px;
          }
        }
        input::placeholder {
          font-size: 14px;
          line-height: 20px;
          color: #d9d9d9;
        }
      }

      .filter_btn {
        flex-shrink: 0;
        @include btn-default(112px, 36px);
        border-radius: 100px;
        margin-left: 17px;
        @include mobile {
          @include btn-default(72px, 36px);
          margin-left: 0;
        }
      }
      .addMoonNote_btn {
        flex-shrink: 0;
        @include btn(40px, 40px, $theme-color-2, #fff);
        border-radius: 50%;
        margin-left: 30px;
        @include pad {
          margin-left: 12px;
          @include btn(36px, 36px, $theme-color-2, #fff);
        }
      }
    }
  }
  .moonlist__export {
    flex-shrink: 0;
    width: 40px;
    height: 40px;
    border-radius: 50%;
    background-color: #798da5;
    color: #fff;
    margin-left: 32px;
    padding: 4px;
    cursor: pointer;
    @include center;
    @include mobile {
      width: 36px;
      height: 36px;
      margin-left: 16px;
    }
    img {
      width: 100%;
      height: 100%;
    }
  }
  .moon_list_option {
    max-width: 600px;
    margin: 54px auto 0;
    display: flex;
    align-items: centeer;
    @include pad {
      margin-top: 40px;
    }
    &_toStatistics,
    &_filter,
    &_sort {
      cursor: pointer;
      border-radius: 30px;
      background: #f0f2f4;
      box-shadow: 0px 6.6px 16.5px 0px rgba(0, 0, 0, 0.1);
      padding: 4px 12px 4px 4px;
      font-size: 15px;
      color: #868686;
      display: flex;
      align-items: center;
      @include pad {
        font-size: 13px;
      }
      .moon_icon {
        width: 28px;
        height: 28px;
        @include pad {
          width: 24px;
          height: 24px;
        }
        img {
          width: 100%;
          height: 100%;
        }
      }
    }
    &_toStatistics {
      padding-left: 12px;
      text-decoration: none;
    }
    &_filter {
      margin-left: auto;
      &.active {
        background-color: #798da5;
        color: #fff;
      }
    }
    &_sort {
      margin-left: auto;
      .moon_icon.sorting {
        transform: rotate(180deg);
      }
    }
  }
  .moon_list_group {
    max-width: 788px;
    margin: 24px auto 0;
    display: flex;
    flex-direction: column;
    align-items: center;
    .row {
      width: 100%;
    }
  }
  .moon_list_empty {
    margin-top: 15vh;
    display: flex;
    flex-direction: column;
    align-items: center;
    .moon_list_empty_title {
      font-size: 20px;
      font-weight: 500;
      line-height: 1;
      color: #868686;
      letter-spacing: 1.2px;
      margin-bottom: 20px;
      @include mobile {
        font-size: 16px;
        margin-bottom: 20px;
      }
    }
    .moon_list_empty_btn {
      @include btn-default(176px, 46px);
      font-size: 16px;
      font-weight: 400;
      line-height: 18px;
      color: #fff;
      @include center;
    }
  }
  //moon tab
  .moon__tab {
    max-width: 600px;
    margin: 24px auto 0;
    position: relative;
    @include align(flex-start, center);
    &__item {
      @include rect(48px, 72px, $theme-color-3, 24px);
      @include center;
      flex-direction: column;
      box-shadow: -1px -1px 4px 0 rgba(238, 109, 175, 0.22), 2px 2px 8px 0 rgba(0, 0, 0, 0.1);
      // transition: 0.2s;
      cursor: pointer;
      img {
        width: 32px;
        @include pad {
          width: 28px;
        }
      }
      &__icon {
        color: #ab956c;
        .iconfont {
          font-size: 28px;
          line-height: 28px;
          @include pad {
            font-size: 22px;
            line-height: 22px;
          }
        }
      }
      &__text {
        writing-mode: vertical-rl;
        color: #9b9b9b;
        font-size: 14px;
        line-height: 1.57;
        letter-spacing: 0.56px;
        display: flex;
        justify-content: center;
        align-items: center;
      }
      &.activeTab {
        background-color: #ab956c;
        .moon__tab__item__icon {
          color: #ffffff;
        }
        .moon__tab__item__text {
          color: #ffffff;
        }
      }
    }
  }
}

//編輯今天
.toEditToday {
  max-width: 788px;
  margin: 30px auto 23px;
  @include mobile {
    margin: 8px auto 16px;
  }
  &__main {
    width: 100%;
    display: flex;
    justify-content: space-between;
    align-items: center;
    gap: 28px;
    &__line {
      flex-grow: 1;
      height: 1px;
      background-color: #ab956c;
    }
    &__info {
      font-size: 24px;
      font-weight: 500;
      line-height: 24px;
      display: flex;
      flex-direction: column;
      align-items: center;
      @include mobile {
        font-size: 16px;
      }
      &__today {
        display: flex;
        align-items: center;
        color: #ab956c;
        margin-bottom: 12px;
        @include mobile {
          margin-bottom: 4px;
        }
        img {
          width: 32px;
          height: 32px;
          margin-right: 8px;
          @include mobile {
            width: 20px;
            height: 20px;
          }
        }
      }
    }
  }
  &__notice {
    display: flex;
    margin-top: 28px;
    &__pic {
      margin-right: 12px;
      img {
        width: 32px;
        height: 32px;
        @include mobile {
          width: 20px;
          height: 20px;
        }
      }
    }
    &__text {
      font-size: 18px;
      font-weight: 400;
      color: #868686;
      @include mobile {
        font-size: 13px;
      }
    }
  }
}
</style>
  